import { screenSmallerThan } from '../../../shared/utilities/screenSize';
import Slider from '../../../framework/slider';
import { debounce } from '../../../shared/utilities/debounce';

export default class Insights extends Slider {
	constructor(element) {
		super({
			element,
			dotContainer: '.v2-slider__dots',
			slideContainer: '.v2-insights__slider',
			createBullets: true,
			sliderOpts: {
				enableMouseEvents: false,
				rewind: false,
				infinite: false
			}
		});

		this.addEventListeners();
		if (window.innerWidth < 769) {
			this.initLory(this.slideContainer);
		}
	}

	addEventListeners() {
		const resizeHandler = debounce(
			() => !this.slider && screenSmallerThan('sm') && this.initLory(this.slideContainer),
			500,
			false
		);
		window.addEventListener('resize', resizeHandler);
	}
}
